import {
  ConfigApi,
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';
import { GetDailyReportRequest, FeedbackRequest } from '../types';

type Options = {
  discoveryApi: DiscoveryApi;
  configApi: ConfigApi;
  fetchApi: FetchApi;
};

export const aiApiRef = createApiRef<AiAPI>({
  id: 'plugin.ai.service',
});

export class AiAPI {
  private readonly backendUrl: string | undefined;
  private readonly fetchApi: FetchApi;

  constructor(options: Options) {
    this.backendUrl = options.configApi.getOptionalString('backend.baseUrl');
    this.fetchApi = options.fetchApi;
  }

  private async getUrls() {
    return `${this.backendUrl}/api/ai/proxy`;
  }

  /**
   * Get Daily Report
   */
  async getDailyReport(body: GetDailyReportRequest[], scope: string): Promise<string> {
    const baseUrl = await this.getUrls();
    const apiUrl = `${baseUrl}/daily-report`;

    const response = await this.fetchApi.fetch(apiUrl, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ reports: body, scope }),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch daily report: ${response.statusText}`);
    }

    const data: { result: string } = await response.json();

    return data.result;
  }

  /**
   * Submit Feedback
   */
  async submitFeedback(feedback: FeedbackRequest): Promise<void> {
    const baseUrl = await this.getUrls();
    const apiUrl = `${baseUrl}/feedback`;

    const response = await this.fetchApi.fetch(apiUrl, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(feedback),
    });

    if (!response.ok) {
      throw new Error(`Failed to submit feedback: ${response.statusText}`);
    }
  }
}
